export default "__VITE_ASSET__DLafG8Dn__"